import { Flex } from 'antd';
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Button, Stack } from '@mui/material';
import EditButton from 'components/button/EditButton';
import FormSubmitButton from 'components/button/FormSubmitButton';
import ActiveDeactivateButton from 'components/button/ActiveDeactiveButton';
import IdentityCaseActivityModal from 'pages/IdentityCase/IdentityCaseActivityModal';

function IdentityActionButton({
	id,
	screen,
	action,
	history,
	version,
	dateTime,
	children,
	detail = {},
	parkAction,
	processName,
	processCode,
	permissions,
	recordStatus,
	processVersion,
	approverUserId,
	activationStatus,
	navigateToEditFunc,
	isOperationLoading,
	deactivateHandlerFunc,
	isHistoryHidden = false,
	approveRejectHandlerFunc,
}) {
	const theme = useTheme();

	const [selectHistory, setSelectHistory] = useState(null);

	return (
		<>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
				<Flex>
					{!isHistoryHidden && (
						<Button
							sx={{
								fontSize: '13px',
								fontWeight: '500',
								lineHeight: '22px',
								borderRadius: '4px',
								padding: '5px 16px',
								color: 'common.white',
								transition: 'all 0.1s',
								bgcolor: 'rgb(3, 57, 108)',

								'&:hover': {
									bgcolor: 'rgb(3, 57, 108)',
								},
							}}
							disabled={history?.length > 0 ? false : true}
							onClick={(e) => {
								e.stopPropagation();

								if (selectHistory === null) {
									setSelectHistory({
										...(detail?.data ?? detail),
										dateTime: detail?.dateTime ?? dateTime,
										approverUserId: detail?.approverUserId ?? approverUserId,
										parkAction: detail?.parkAction ?? parkAction,
										activationStatus: detail?.activationStatus ?? activationStatus,
										id: detail?._id ?? id,
									});
								} else {
									setSelectHistory(null);
								}
							}}
						>
							History
						</Button>
					)}
					{children}
				</Flex>

				<Stack direction="row" sx={{ gap: '8px' }}>
					{recordStatus === 'saved' && (
						<>
							{/* <Button
								disabled={false}
								type="primary"
								style={{
									marginRight: '3px',
									backgroundColor: activationStatus === 'Active' ? theme.palette.lynTheme.delete : theme.palette.lynTheme.success,
								}}
								onClick={(e) => {
									e.stopPropagation();
									deactivateHandlerFunc(activationStatus);
								}}
							>
								{activationStatus === 'Active' ? 'Deactivate' : 'Activate'}
							</Button> */}

							<ActiveDeactivateButton
								activationStatus={activationStatus}
								handleOnClick={() => {
									deactivateHandlerFunc(activationStatus);
								}}
							/>

							{permissions['edit'] && screen?.toLowerCase() === 'view' && (
								<EditButton
									handleOnClick={() => {
										navigateToEditFunc();
									}}
								/>

								// <Button
								// 	disabled={false}
								// 	icon={<img src={editIcon} width={16} height={16} alt="edit" />}
								// 	onClick={(e) => {
								// 		e.stopPropagation();
								// 		navigateToEditFunc();
								// 	}}
								// 	style={{ marginRight: '3px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
								// >
								// 	Edit
								// </Button>
							)}
						</>
					)}

					{recordStatus === 'parked' && permissions?.approve && (
						<>
							<Button
								disabled={false}
								sx={{
									color: 'white',
									lineHeight: '20px',
									background: 'rgb(3, 57, 108)',

									'&:hover': { background: 'rgb(3, 57, 108)' },
								}}
								onClick={() => {
									approveRejectHandlerFunc('approve-single', id);
								}}
							>
								Approve
							</Button>

							<Button
								disabled={false}
								sx={{
									color: 'white',
									lineHeight: '20px',
									background: theme.palette.lynTheme.delete,

									'&:hover': { background: theme.palette.lynTheme.delete },
								}}
								onClick={() => {
									approveRejectHandlerFunc('reject-single', id);
								}}
							>
								Reject
							</Button>
						</>
					)}

					{screen.toLowerCase() === 'edit' && <FormSubmitButton activate={isOperationLoading && action === 'update'} detail={true} />}
				</Stack>
			</Box>

			{selectHistory && (
				<IdentityCaseActivityModal
					title={processName}
					processCode={processCode}
					selectItem={selectHistory}
					processVersion={processVersion}
					setSelectHistory={setSelectHistory}
				/>
			)}
		</>
	);
}

export default IdentityActionButton;
